/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from "axios"
import { message } from "antd"
import { MessageType } from "antd/lib/message"
import { debounce } from "lodash"
import { API } from "@/constants/config"

/**
 ** 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
const tip = (msg: string) => {
  message.warn(msg)
}

/**
 ** 加载层
 */

let hide: MessageType
//
const loading = debounce(
  () => {
    hide = message.loading({
      content: "loading...",
    })
  },
  1000,
  {
    leading: true,
    trailing: false,
  }
)

// 关闭加载层

const hiding = () => {
  if (hide) {
    hide()
    hide = undefined
  }
}

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  // Env.login()
}

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status: number, message?: string) => {
  // 状态码判断
  switch (status) {
    // 400: 有可能是参数不合法
    case 400:
      message ? tip(message) : tip(`参数不合法`)
      break
    // 401: token date error
    case 401:
      tip("登录过期，请重新登录")
      setTimeout(() => {
        toLogin()
      }, 1000)
      break
    // 403: 未登录状态，跳转登录页
    case 403:
      tip("未登录，请登录")
      // 401 token过期
      // 清除token并跳转登录页
      setTimeout(() => {
        toLogin()
      }, 1000)
      break
    // 404请求不存在
    case 404:
      tip("请求的资源不存在")
      break
    default:
      console.log(
        `错误码为${status},https://www.google.com/search?q=%E9%94%99%E8%AF%AF%E7%A0%81${status}&ie=utf-8`
      )
  }
}

// 创建axios实例
const instance = axios.create({
  baseURL: API,
  // baseURL: `http://192.168.129.11:8080`,
})

// 设置post请求头
instance.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded"

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  // 在发送请求之前做些什么
  (config) => {
    // 遮蔽式请求框
    // loading()
    // 登录流程控制中，根据本地是否存在token判断用户的登录情况
    // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
    // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
    // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
    // const token = Env.getUser()["potoken"]
    // token && (config.headers.token = token)
    return config
  },
  (error) => {
    hiding()
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  (res) => {
    hiding()
    return res.status >= 200 && res.status < 300
      ? Promise.resolve(res.data)
      : Promise.reject(res)
  },
  // 请求已发出，但是不在2xx的范围
  (error) => {
    hiding()
    const { response } = error
    // 对响应错误做点什么
    if (response) {
      const { status, data } = response
      const message = data && data.message
      errorHandle(status, message)
      return Promise.reject(error)
    }
  }
)

export default instance
